import { css } from 'styled-components';

import { PAYMENT_METHOD_OPTION_HEIGHT } from './constants';

export const baseLinkCss = css`
  width: 100%;
  height: ${PAYMENT_METHOD_OPTION_HEIGHT}rem;
  background-color: transparent;
  border: none;
  cursor: pointer;
`;
